"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTemplateInVariant = instanceOfTemplateInVariant;
exports.TemplateInVariantFromJSON = TemplateInVariantFromJSON;
exports.TemplateInVariantFromJSONTyped = TemplateInVariantFromJSONTyped;
exports.TemplateInVariantToJSON = TemplateInVariantToJSON;
exports.TemplateInVariantToJSONTyped = TemplateInVariantToJSONTyped;
const template_1 = require("./template");
/**
 * Check if a given object implements the TemplateInVariant interface.
 */
function instanceOfTemplateInVariant(value) {
    if (!('template' in value) || value['template'] === undefined)
        return false;
    if (!('zoneLocations' in value) || value['zoneLocations'] === undefined)
        return false;
    if (!('battlefieldCardState' in value) || value['battlefieldCardState'] === undefined)
        return false;
    if (!('exileCardState' in value) || value['exileCardState'] === undefined)
        return false;
    if (!('libraryCardState' in value) || value['libraryCardState'] === undefined)
        return false;
    if (!('graveyardCardState' in value) || value['graveyardCardState'] === undefined)
        return false;
    if (!('mustBeCommander' in value) || value['mustBeCommander'] === undefined)
        return false;
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    return true;
}
function TemplateInVariantFromJSON(json) {
    return TemplateInVariantFromJSONTyped(json, false);
}
function TemplateInVariantFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'template': (0, template_1.TemplateFromJSON)(json['template']),
        'zoneLocations': json['zoneLocations'],
        'battlefieldCardState': json['battlefieldCardState'],
        'exileCardState': json['exileCardState'],
        'libraryCardState': json['libraryCardState'],
        'graveyardCardState': json['graveyardCardState'],
        'mustBeCommander': json['mustBeCommander'],
        'quantity': json['quantity'],
    };
}
function TemplateInVariantToJSON(json) {
    return TemplateInVariantToJSONTyped(json, false);
}
function TemplateInVariantToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'quantity': value['quantity'],
    };
}
//# sourceMappingURL=templateInVariant.js.map